import React, { useState, useEffect } from "react";
import { EnvironmentConfig } from "../config/environmentConfig";

//const DATA_URL = 'https://global.occtoo.com/alligotest/etim/v6/';
const managementBaseUrl = EnvironmentConfig.api.baseUrl;

function UnitPage() {
  const [unitList, setUnitList] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const itemsPerPage = 10;

  const [newUnit, setNewUnit] = useState({ unitId: "", unit: "" });
  const [editUnitId, setEditUnitId] = useState(null);
  const [editUnitData, setEditUnitData] = useState({ unit: "" });
  const [editOldKeyData, setOldKeyData] = useState({ oldUnitKey: "" });

  // Hämta alla enheter
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const dataRes = await fetch(`${managementBaseUrl}/units?top=300`);
        const data = await dataRes.json();
        setUnitList(data.results);
        setFilteredUnits(data.results);
      } catch (error) {
        console.error("Fel vid hämtning från Occtoo:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Sökfunktion
  useEffect(() => {
    const filtered = unitList.filter(
      (u) =>
        u.unitId.toLowerCase().includes(searchTerm.toLowerCase()) ||
        u.unit.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUnits(filtered);
    setCurrentPage(1);
  }, [searchTerm, unitList]);

  // Paginering
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUnits = filteredUnits.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredUnits.length / itemsPerPage);

  const handleAdd = () => {
    if (!newUnit.unitId || !newUnit.unit) return;
    const updated = [...unitList, newUnit];
    setUnitList(updated);
    setNewUnit({ unitId: "", unit: "" });
  };

  const handleDelete = (id) => {
    const updated = unitList.filter((u) => u.unitId !== id);
    setUnitList(updated);
  };

  const handleEdit = (unit) => {
    setEditUnitId(unit.unitId);
    setEditUnitData({ unit: unit.unit });
    setOldKeyData({ oldUnitKey: unit.oldUnitKey });
  };

  const handleSaveEdit = () => {
    const updated = unitList.map((u) =>
      u.unitId === editUnitId
        ? { ...u, unit: editUnitData.unit, oldUnitKey: editOldKeyData.oldUnitKey }
        : u
    );
    setUnitList(updated);
    setEditUnitId(null);
    setEditUnitData({ unit: "" });
    setOldKeyData({ oldUnitKey: "" });
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Hantera Enheter</h2>

      {/* Loader */}
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Laddar...</span>
          </div>
          <p>Laddar enheter...</p>
        </div>
      ) : (
        <>
          {/* Lägg till ny enhet */}
          <div className="card mb-4">
            <div className="card-header">Lägg till ny enhet</div>
            <div className="card-body">
              <div className="row g-2">
                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Enhets-ID"
                    value={newUnit.unitId}
                    onChange={(e) => setNewUnit({ ...newUnit, unitId: e.target.value })}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    className="form-control"
                    placeholder="Enhetsnamn"
                    value={newUnit.unit}
                    onChange={(e) => setNewUnit({ ...newUnit, unit: e.target.value })}
                  />
                </div>
                <div className="col-md-2">
                  <button className="btn btn-outline-dark btn w-100" onClick={handleAdd}>
                    Lägg till
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Sökfält */}
          <h5>Hitta enhet</h5>
          <div className="mb-3">
            <input
              className="form-control"
              placeholder="Sök enhet..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* Lista */}
          <h5>Enhetslista</h5>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Namn</th>
                <th>Gammal Inriver Nyckel</th>
                <th>Åtgärder</th>
              </tr>
            </thead>
            <tbody>
              {currentUnits.map((u) => (
                <tr key={u.unitId}>
                  <td>{u.unitId}</td>
                  <td>
                    {editUnitId === u.unitId ? (
                      <input
                        className="form-control"
                        value={editUnitData.unit}
                        onChange={(e) => setEditUnitData({ unit: e.target.value })}
                      />
                    ) : (
                      u.unit
                    )}
                  </td>
                  <td>
                    {editUnitId === u.unitId ? (
                      <input
                        className="form-control"
                        value={editOldKeyData.oldUnitKey}
                        onChange={(e) => setOldKeyData({ oldUnitKey: e.target.value })}
                      />
                    ) : (
                      u.oldUnitKey
                    )}
                  </td>
                  <td>
                    {editUnitId === u.unitId ? (
                      <button className="btn btn-sm btn-success me-2" onClick={handleSaveEdit}>
                        Spara
                      </button>
                    ) : (
                      <button className="btn btn-sm btn-dark me-2" onClick={() => handleEdit(u)}>
                        Redigera
                      </button>
                    )}
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(u.unitId)}
                    >
                      Radera
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Paginering */}
          <nav>
            <ul className="pagination justify-content-center">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage((prev) => prev - 1)}>
                  Föregående
                </button>
              </li>
              {[...Array(totalPages)].map((_, i) => (
                <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage((prev) => prev + 1)}>
                  Nästa
                </button>
              </li>
            </ul>
          </nav>
        </>
      )}
    </div>
  );
}

export default UnitPage;
